import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'
import Modal from '@components/common/modal'
import { ACTIVITIES } from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'
import { useState } from 'react'

const IMAGE_PATH = '/images/courses/'

type Props = {
  courseName: CourseNameType
}

const Activities = ({ courseName }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [activityLink, setActivityLink] = useState<string>(null)
  const [videoLink, setVideoLink] = useState<string>(null)

  const coursesActivities = ACTIVITIES[courseName]

  return (
    <div className="mt-16 mb-8 flex flex-col text-grey">
      <h2 className="text-2xl font-600 leading-tight">
        {coursesActivities.title}
      </h2>
      {coursesActivities.description && (
        <p className="text-lg mt-4">{coursesActivities.description}</p>
      )}
      <div className="flex mt-4 flex-wrap justify-center">
        {coursesActivities.activities.map((activities) => (
          <div
            key={activities.activityName}
            className="w-full md:w-1/2 lg:w-1/3 max-w-full my-2 px-1 bg-white"
            onClick={() => {
              ;(activities.iframeURL || activities.videoURL) && setIsOpen(true)
              activities.iframeURL &&
                (setActivityLink(activities.iframeURL), setVideoLink(null))
              activities.videoURL &&
                (setVideoLink(activities.videoURL), setActivityLink(null))
            }}
          >
            <div className="rounded-md shadow-md hover:shadow-xl transition duration-500 cursor-pointer h-full flex flex-col">
              <FastlyImage
                src={`${IMAGE_PATH}${activities.activityImage}.png`}
                webpSrc={`${IMAGE_PATH}${activities.activityImage}.webp`}
                width={492}
                height={334}
                objectFit="fill"
                alt={activities.activityName}
              />
              <div className="p-3">
                <h3 className="text-xl font-600 mb-2 leading-tight">
                  {activities.activityName}
                </h3>
                <p className="leading-tight">
                  {activities.activityDescription}
                </p>
              </div>
              <div className="p-3 mt-auto">
                {activities.videoURL && (
                  <Button variant="outline" className="w-full">
                    <a href={activities.videoURL}>Watch video</a>
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
        {coursesActivities.conclusion && (
          <div className="text-lg mt-4 space-y-4">
            {coursesActivities.conclusion}
          </div>
        )}
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} isCrossIconShown={true}>
        <>
          {' '}
          {activityLink && (
            <iframe
              src={activityLink}
              width="485"
              height="402"
              scrolling="no"
              className="border border-grey-600 rounded-md max-w-full"
            />
          )}
          {videoLink && (
            <video
              controlsList="nodownload"
              controls
              autoPlay
              className="-my-5 sm:-my-10 rounded-lg mx-auto"
              style={{ height: '80vh' }}
            >
              <source src={videoLink} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </>
      </Modal>
    </div>
  )
}

export default Activities
